import { render, staticRenderFns } from "./EfsMdArchivesModal.vue?vue&type=template&id=16d4cb24&"
import script from "./EfsMdArchivesModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdArchivesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports